import React from 'react';
import Box from '@mui/material/Box';
import {useTheme} from "@mui/material/styles";
import {Typography} from "@mui/material";

export const Privacy: React.FC = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                paddingTop: theme.spacing(3),
            }}
        >
            <Typography variant="h3">
                Data Axle
            </Typography>
            <Typography variant="subtitle1">
                Privacy page
            </Typography>
        </Box>
    );
}
